import React from "react";
import { Box, Typography } from "@mui/material";

import StandardButton from "./StandardButton";

import ExerciseGroupImage from "../components/ExerciseGroupImage";

const MuscleGroupButton = ({ id, title, filter, onClick }) => {
  if (id === filter) {
    return (
      <StandardButton
        variant="selected"
        sx={{ height: 60, width: 100, margin: 0 }}
        onClick={() => {
          if (onClick) {
            onClick(id);
          }
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <ExerciseGroupImage id={id} selected={true} width={32} />
          <Typography
            variant="caption"
            sx={{ fontSize: "0.75rem", textAlign: "center" }}
          >
            {title}
          </Typography>
        </Box>
      </StandardButton>
    );
  }
  return (
    <StandardButton
      variant="primary"
      sx={{ height: 60, width: 100, margin: 0 }}
      onClick={() => {
        if (onClick) {
          onClick(id);
        }
      }}
    >
      <Box
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        <ExerciseGroupImage id={id} selected={true} width={32} />
        <Typography
          variant="caption"
          sx={{ fontSize: "0.75rem", textAlign: "center" }}
        >
          {title}
        </Typography>
      </Box>
    </StandardButton>
  );
};

export default MuscleGroupButton;
